import img1 from "../../assets/Images/Access Control/Role Management.png"
import img3 from "../../assets/Images/Access Control/Create Role.png"

export default function Roles() {
    return (
        <section id="roles" className="space-y-16">

            {/* SECTION TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    1. Role Management
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    Roles define user responsibilities and determine the level of access
                    within the system.
                </p>

                <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
                    <h2 className="text-lg font-semibold mb-3">Overview</h2>
                    <p className="text-slate-600 text-sm">
                        A role represents a group of permissions assigned to users performing
                        similar duties, such as Admin, Manager, Staff, or Cashier.
                    </p>
                </section>
            </section>

            {/* ROLE LIST */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">Roles List</h3>

                    <p className="text-slate-600 mb-4">
                        The Roles List displays all system roles with their current status.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Role Name (e.g. Admin, Manager, Staff)</li>
                        <li>Status (Active / Inactive)</li>
                        <li>Creation Date</li>
                        <li>Edit action</li>
                    </ul>
                </div>

                <div className=" rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ADD ROLE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Creating a New Role</h3>

                <p className="text-slate-600 mb-4">
                    Clicking <strong>Add New</strong> opens the Create Role form.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Enter Role Name (e.g. Manager)</li>
                    <li>Save to register the role</li>
                    <li>Cancel to exit without changes</li>
                </ul>

                <div className=" rounded-lg p-4 mt-4">
                    <img src={img3} alt="" />
                </div>
            </section>

            {/* EDIT ROLE */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Editing Roles</h3>

                <p className="text-slate-600">
                    The Edit option allows administrators to update role names or adjust
                    role configurations if required.
                </p>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">Why Role Management Matters</h3>

                <p className="text-slate-600 max-w-3xl">
                    Proper role management ensures security, accountability, and controlled
                    access to sensitive operations across the system.
                </p>
            </section>

        </section>
    );
}
